import { formatDistanceToNow } from 'date-fns';

export const AdminMessage = ({ message, messageUpdatedAt, isOnline }) => {
  if (!message) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: '#1A202C',
        border: '2px solid #E5A100',
        borderRadius: '8px',
        padding: '20px',
        margin: '30px 0',
        maxWidth: '100%'
      }}
    >
      <h2
        style={{
          color: '#E5A100',
          margin: '0 0 15px 0',
          fontSize: '18px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}
      >
        {isOnline ? '⚠️ Service Notice' : '🔴 Status Update'}
      </h2>

      <p
        style={{
          color: '#FFFFFF',
          fontSize: '18px',
          lineHeight: '1.6',
          margin: '0 0 10px 0',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      >
        {message}
      </p>

      {messageUpdatedAt && (
        <p
          style={{
            color: '#718096',
            fontSize: '14px',
            margin: '10px 0 0 0',
            fontStyle: 'italic'
          }}
        >
          Posted {formatDistanceToNow(messageUpdatedAt, { addSuffix: true })}
        </p>
      )}
    </div>
  );
};

export default AdminMessage;
